import { z } from 'zod';

import type { AlgoliaFacet } from '@jane/bloom/types/schemas/algolia/facets';

export enum SortOptions {
  alphabetical = 'alphabetical',
  featured = 'featured',
  price = 'price',
  priceDesc = 'priceDesc',
  rating = 'rating',
  recommended = 'recommended',
  thcAsc = 'thcAsc',
  thcDesc = 'thcDesc',
}

export const SortOptionsSchema = z.nativeEnum(SortOptions);

export enum MenuProductSortSuffix {
  Alphabetical = '',
  Default = '', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  Featured = '', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  Price = 'by-price-',
  PriceDesc = 'by-price-desc-',
  Rating = 'by-rating-',
  Recommended = 'by-recommendation-ordinal-asc-',
  ThcAsc = 'by-thc-potency-asc-',
  ThcDesc = 'by-thc-potency-desc-',
}

export type AlgoliaProductFacets = {
  activities?: AlgoliaFacet;
  aggregate_rating?: AlgoliaFacet;
  applicable_brand_special_ids?: AlgoliaFacet;
  applicable_bulk_special_ids?: AlgoliaFacet;
  applicable_bundle_special_ids?: AlgoliaFacet;
  'applicable_bundle_special_ids.discount'?: AlgoliaFacet;
  'applicable_bundle_special_ids.qualify'?: AlgoliaFacet;
  applicable_cart_total_special_ids?: AlgoliaFacet;
  applicable_special_ids?: AlgoliaFacet;
  available_weights?: AlgoliaFacet;
  brand?: AlgoliaFacet;
  brand_subtype?: AlgoliaFacet;
  bucket_price?: AlgoliaFacet;
  category?: AlgoliaFacet;
  feelings?: AlgoliaFacet;
  has_brand_discount?: AlgoliaFacet;
  kind?: AlgoliaFacet;
  percent_cbd?: AlgoliaFacet;
  percent_thc?: AlgoliaFacet;
  root_types?: AlgoliaFacet;
};
